<template>
<div class="app">
  <router-view></router-view>
</div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
html, body {
	height: 100%;
	margin: 0;
}
body {
  font-family: "HelveticaNeue", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #4C595E;
}
.app {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-content: stretch;
  width: 100%;
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// App.vue?0ae871c6